import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/start.png'
import _imports_1 from '../assets/img/rank.png'


const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1hb51k7ht1lfc5cg15ne1sku1n1ib.png",
  alt: "",
  class: "panda"
}, null, -1)
const _hoisted_3 = { class: "foot" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "unit" }, "主办单位：四川省网络治理研究中心   承办单位：封面新闻", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("img", {
        src: _imports_0,
        alt: "",
        class: "start",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleStart(false)))
      }),
      _createVNode("img", {
        src: _imports_1,
        alt: "",
        class: "rank",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRank && _ctx.onRank(...args)))
      }),
      _hoisted_4
    ])
  ]))
}